import Vue from 'vue'
export default Vue.observable({
  mainMenu: false,
  currentVideoID: null
})
